import React from 'react';
import * as s from './styles';

const AccessibleHealthProgram = ({ imageSrc, additionalImageSrc }) => {
  const handleClick = () => {
    window.location.href = 'https://bluemed.cc/';
  };
  return (
    <>
      <s.Logo src='/assets/logo-blue.svg' alt='Logo' />
      <s.BannerContainer>
        <s.AdditionalContent>
          <s.ParagraphFeatured>
            Nosso programa oferece óleo de cannabis a preços fixos com descontos
            significativos, incluindo uma série de benefícios para garantir que
            seu tratamento não seja apenas eficaz, mas também acessível.
          </s.ParagraphFeatured>
          <s.Image src={additionalImageSrc} alt='Blue Pharm' />
          <s.Paragraph>
            Na Blue Pharm, estamos comprometidos em tornar o tratamento com
            cannabis medicinal acessível para todos, para estar elegível você
            tem que ser um Microempreendedor Individual ou receber auxílio do
            Bolsa Família.
          </s.Paragraph>
          <s.Paragraph>
            Nosso programa inclusivo oferece uma associação para indivíduos e
            famílias que estão procurando por tratamentos com cannabis medicinal
            para os seguintes diagnósticos.
          </s.Paragraph>
          <s.DiagnosisContainer>
            <s.Diagnosis>Autismo</s.Diagnosis>
            <s.Diagnosis>Alzheimer</s.Diagnosis>
            <s.Diagnosis>Parkinson</s.Diagnosis>
            <s.Diagnosis>Fibromialgia</s.Diagnosis>
            <s.Diagnosis>Artrite</s.Diagnosis>
            <s.Diagnosis>Artrose</s.Diagnosis>
            <s.Diagnosis>Convulsões</s.Diagnosis>
            <s.Diagnosis>Depressão</s.Diagnosis>
          </s.DiagnosisContainer>
          <s.Paragraph>
            Ao se qualificar para nosso programa, o acesso a consultas médicas
            se torna gratuito. Sabemos que cada paciente tem necessidades
            únicas, por isso oferecemos não só o frete gratuito, mas também a
            quantidade necessária de óleo de cannabis para o período completo do
            tratamento a um preço fixo mensal. Isso significa que o paciente
            pode se concentrar na sua saúde sem se preocupar com custos
            variáveis.
          </s.Paragraph>
          <s.Paragraph>
            Para participar, basta se registrar em nossa plataforma, indicando
            sua condição de MEI ou de recebedor do programa Bolsa Família.
          </s.Paragraph>
          <s.Paragraph>
            Preencha seu formulário de inscrição e nossa equipe entrara em
            contato com você
          </s.Paragraph>
          {/* <Button onClick={handleClick}>Fale com um Médico</Button> */}
        </s.AdditionalContent>

        <s.AddImage src={additionalImageSrc} alt='Blue Pharm' />
      </s.BannerContainer>
    </>
  );
};

export default AccessibleHealthProgram;
